import React from "react";
import { UserPlusIcon } from "@heroicons/react/24/solid";

const SELF_REPORTED_DATA = "self_reported_company_data";

export function isSelfReportedData(localLabel: string) {
    return localLabel.includes(SELF_REPORTED_DATA);
}

function SelfReportedTooltip() {
    const [tooltipPosition, setTooltipPosition] = React.useState<{
        top: number;
        left: number;
        position: "left" | "right";
    }>({
        top: -9999,
        left: -9999,
        position: "right",
    });
    const [isVisible, setIsVisible] = React.useState(false);
    const triggerRef = React.useRef<HTMLSpanElement>(null);

    const handleMouseEnter = React.useCallback(() => {
        setIsVisible(true);
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const tooltipWidth = 320;

            const wouldOverflowRight =
                rect.right + tooltipWidth > viewportWidth;
            const position = wouldOverflowRight ? "left" : "right";

            const top = rect.bottom + 8;
            const left =
                position === "right"
                    ? rect.left
                    : Math.max(0, rect.right - tooltipWidth);

            setTooltipPosition({ top, left, position });
        }
    }, []);

    const handleMouseLeave = React.useCallback(() => {
        setIsVisible(false);
    }, []);

    return React.createElement(
        "span",
        {
            ref: triggerRef,
            className: "tt-trigger group relative",
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
        },
        React.createElement(
            "span",
            {
                className:
                    "flex items-center justify-center rounded-full bg-slate-600 px-2 py-1",
            },
            React.createElement(UserPlusIcon, {
                className: "h-4 w-4",
            }),
        ),
        isVisible &&
            React.createElement(
                "div",
                {
                    className: `tt-container tt-${tooltipPosition.position} !fixed`,
                    style: {
                        top: `${tooltipPosition.top}px`,
                        left: `${tooltipPosition.left}px`,
                    },
                },
                React.createElement(
                    "div",
                    { className: "tt w-80" },
                    "This is self-reported data by the company. There is no period over period comparison available for this data point.",
                ),
            ),
    );
}

export function createLabelWithSelfReportedIcon(label: string) {
    return React.createElement(
        "span",
        { className: "flex items-center gap-2" },
        label,
        React.createElement(SelfReportedTooltip),
    );
}
